export default {
  black1: '#514949',
  gray1: '#ABABAB',
  gray2: '#E4E4E4',
  gray3: '#E4E6EF',
  orange1: '#FF9500',
  white1: '#FFFFFF',
  white2: '#FAFAFA'
}
